import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../service/auth.service";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    public toastr: ToastrService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        // if ([401,403].includes(err.status) && this.authenticationService.userValue) {
        if ([401, 403].includes(err.status)) {
          // auto logout if 401 or 403 response returned from api
          if (err.error) {
            this.toastr.error(err.error[0].description, "Error", {
              timeOut: 2000,
            });
          } else {
            this.toastr.error("Authentication Failed!", "Error", {
                timeOut: 2000,
              });
          }
          this.authenticationService.logout();
        }
        const error = (err && err.error && err.error.message) || err.statusText;
        console.error(err);
        return throwError(error);
      })
    );
  }
}
